<p-panel>
  <p-header class="header-row">
    <div class="filter-row">
      <button class="close-profile-button" pButton icon="pi pi-times" (click)="closeUserProfile()"></button>
      <div>
        <h2>{{user.name}}</h2>
        <div><em>{{user.username}}</em></div>
      </div>

    </div>
    <div class="filter-row">
      <a href="{{ documentProtocol }}//{{ documentHostname }}/users/edit-user/{{user.id}}">
        @if (userCanEdit()) {
          <button pButton
            class="p-button-success edit-user-button"
            icon="pi pi-pencil"
            label="Edit User">
          </button>
        }
      </a>
      <a href="{{ documentProtocol }}//{{ documentHostname }}/users/edit-user-account-access/{{user.id}}">
        @if (userCanEdit()) {
          <button pButton
            class="p-button-success user-account-access-button"
            icon="pi pi-pencil"
            label="Edit User Account Access">
          </button>
        }
      </a>
    </div>
  </p-header>
  <div class="modal-button-wrapper">
    <p-confirmDialog key="sendResetPasswordLink"></p-confirmDialog>
  </div>
  <button pButton class="reset-button" label="Reset Password" (click)="openResetPasswordLinkModal()"></button>
  <div class="account-log-component">
    <div>
      <h3>Account Information</h3>
      <div class="information-label">
        <label><b>Active: </b>
        @if (user.active) {
          <i class="pi pi-check green-checkmark profile-icon-style"></i>
        }
        @if (!user.active) {
          <i class="pi pi-times red-cross profile-icon-style"></i>
        }
      </label>
    </div>
    <div class="information-label">
      <label><b>User Type: </b> {{user.userType}}</label>
    </div>
    @if (user.dealerAccountGroup !== '') {
      <div class="information-label">
        <label><b>Dealer Group: </b> {{user.dealerAccountGroup.split(':')[0]}}</label>
      </div>
    }
    <div class="information-label">
      <label><b>Role: </b> {{user.role}}</label>
    </div>
    <div class="information-label">
      <label><b>Multi-Factor Authentication: </b>
      @if (user.tfaCodeRequired) {
        <i class="pi pi-check green-checkmark profile-icon-style"></i>
      }
      @if (!user.tfaCodeRequired) {
        <i class="pi pi-times red-cross profile-icon-style"></i>
      }
    </label>
  </div>
  <div class="information-label">
    <label><b>Receive Text Messages: </b>
    @if (user.receiveTexts) {
      <i class="pi pi-check green-checkmark profile-icon-style"></i>
    }
    @if (!user.receiveTexts) {
      <i class="pi pi-times red-cross profile-icon-style"></i>
    }
  </label>
</div>
<div class="information-label">
  <label><b>Receive MPOP Alerts via Email: </b>
  @if (user.receiveEmails) {
    <i class="pi pi-check green-checkmark profile-icon-style"></i>
  }
  @if (!user.receiveEmails) {
    <i class="pi pi-times red-cross profile-icon-style"></i>
  }
</label>
</div>
</div>
<div class="login-log">
  <h3>Recent Logins</h3>
  @if (loginLogsLoading) {
    <div>
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  @if (!loginLogsLoading) {
    <div>
      @if (hasRecentLogins()) {
        <div>
          @for (login of user.recentLogins; track login.created) {
            <div class="login-log-field">
              <label>{{login.created}}</label>
            </div>
          }
        </div>
      } @else {
        <div class="login-log-field">
          <label>No recent logins</label>
        </div>
      }
    </div>
  }
</div>
</div>
<div>
  <h3>Contact Information</h3>
  <div class="information-label">
    <label><b>Email: </b> {{user.email}}</label>
  </div>
  <div class="information-label">
    <label><b>Phone: </b> {{user.phone}}</label>
  </div>
</div>
<div class="created-label">
  <label><em>Created: </em> {{user.created}}</label>
</div>
</p-panel>
